(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeCardSummary', PropriedadeCardSummary);

  function PropriedadeCardSummary() {
    return {
      restrict: 'E',
      controller: 'PropriedadeCardSummaryCtrl',
      controllerAs: 'card',
      templateUrl: 'views/propriedade/propriedade-card-summary.html',
      require: ['propriedadeCardSummary', '^propriedadeCards'],
      scope: {
        summary: '='
      },
      link: function link(_scope, _element, _attrs, controllers) {
        var summary = controllers[0];
        var cards = controllers[1];

        summary.init(cards);
      }
    };
  }

}());
